import StripeHandler from "./StripeHandler";
export default StripeHandler;